import { ArrowDownRight } from "lucide-react";

export default function CTABanner() {
  return (
    <section
      data-testid="cta-banner"
      className="relative bg-[#070809] border-y border-white/10 py-20 md:py-28 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
        <div className="lg:col-span-8">
          <div className="flex items-center gap-3 mb-6">
            <span className="block w-10 h-px bg-[#C2A878]" />
            <span className="text-xs tracking-[0.3em] uppercase text-[#C2A878] font-semibold">
              Ready when you are
            </span>
          </div>
          <h2
            data-testid="cta-banner-headline"
            className="font-serif font-light text-4xl md:text-5xl lg:text-6xl leading-[1.05] text-white tracking-tight"
          >
            Let&apos;s get you the results{" "}
            <em className="text-[#C2A878] not-italic">you deserve.</em>
          </h2>
          <p className="mt-6 max-w-xl text-white/65 text-base md:text-lg leading-relaxed">
            Tell us about your property. Within one business day we&apos;ll come
            back with specific opportunities we see in your operation.
          </p>
        </div>

        <div className="lg:col-span-4 lg:justify-self-end">
          <a
            href="#audit"
            data-testid="cta-banner-button"
            className="group inline-flex items-center gap-3 bg-[#C2A878] hover:bg-[#D4AF37] text-[#050505] px-8 py-5 text-xs font-semibold tracking-[0.2em] uppercase transition-all duration-300"
          >
            Claim my audit
            <ArrowDownRight className="w-4 h-4 transition-transform group-hover:translate-x-1 group-hover:translate-y-1" />
          </a>
        </div>
      </div>
    </section>
  );
}
